<template>
  <v-card
    class="rounded-md mt-2 mb-2 indigo lighten-5"
    v-if="configPcd && configPcd.indicar_pcd"
    outlined
    style="border-color: white !important"
  >
    <v-card-title class="subtitle-1 indigo--text font-weight-bold"
      >Indicar PCD</v-card-title
    >
    <v-card-text>
      <v-row dense>
        <v-col cols="auto" align-self="center">
          <v-icon size="62" color="indigo">mdi-human-wheelchair</v-icon>
        </v-col>
        <v-col class="ml-5" v-if="configPcd">
          <span
            class="title indigo--text"
            style="font-family: 'Carter One' !important"
            >{{ configPcd.texto_pcd }}</span
          >
          <v-row dense>
            <v-col lg="6" md="6" xl="6" cols="12" align-self="center">
              <v-btn
                rounded
                color="indigo"
                dark
                block
                to="/indicar-pcd"
                class="mt-3 subtitle-1"
                :style="{
                  'font-family': 'Carter One !important',
                  'letter-spacing': '1px !important',
                }"
                >Indicar PCD</v-btn
              >
            </v-col>
            <v-col lg="6" md="6" xl="6" cols="12" align-self="center">
              <v-dialog v-model="dialog" max-width="750" scrollable>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    text
                    rounded
                    color="indigo"
                    v-on="on"
                    v-bind="attrs"
                    block
                    class="mt-3"
                    small
                    >Mais informações</v-btn
                  >
                </template>
                <orientacoes-indicacao-pcd>
                  <v-spacer></v-spacer>
                  <v-btn text @click="dialog = false" rounded>Fechar</v-btn>
                </orientacoes-indicacao-pcd>
              </v-dialog>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState } from "vuex";
import OrientacoesIndicacaoPcd from "./OrientacoesIndicacaoPcd.vue";
export default {
  components: { OrientacoesIndicacaoPcd },
  computed: mapState("pcd", ["configPcd"]),
  data: () => ({
    dialog: false,
  }),
};
</script>

<style>
</style>